/**
 * Page orientation values.
 */
export enum PageOrientationEnum {
	PORTRAIT = 'portrait',
	LANDSCAPE = 'landscape',
}
